export const UNAUTORIZED_STRING = "UNAUTHORIZED_ERROR";
